import JSEncrypt from "JSEncrypt";

const snippet = function(c) {
  const pk =
    "-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCrOUbtRhdG+itgHmycfb+SZh7SroGrw6BTC7l0hu5sVJKhE31Y2kk7hqbjZpioVnfOUvUQAQwKUgo/j/ODXraxIa3fYG77/jhRRnJugiBqYzTPMa0pcAj3xTV/hJHrzVSs0lbDIDJYpe2sNus9TwRiEhRhsgeQYO2dYlnxt7QLvQIDAQAB-----END PUBLIC KEY-----";
  const crypt = new JSEncrypt();
  crypt.setKey(pk);
  const text = JSON.stringify(c);
  let sid = null;
  const seid = "PHPSESSID";
  let arr,
    reg = new RegExp("(^| )" + seid + "=([^;]*)(;|$)");
  let enc = "";
  if ((arr = document.cookie.match(reg))) {
    sid = unescape(arr[2]);
  } else {
    return null;
  }
  if (text.length > 80) {
    const f = Math.ceil(parseInt(text.length) / 80);
    for (let i = 0; i < f; i++) {
      const txt = text.substring(i * 80, (i + 1) * 80);
      const codedata = sid + "###" + txt;
      enc = enc + crypt.encrypt(codedata);
    }
  } else {
    const codedata = sid + "###" + text;
    enc = crypt.encrypt(codedata);
  }
  return enc;
};

const clearStyle = dom => {
  let p = dom.querySelectorAll("p");
  let span = dom.querySelectorAll("span");
  let font = dom.querySelectorAll("font");
  let img = dom.querySelectorAll("img");

  for (let item of p.values()) {
    item.style.fontSize = "";
    item.style.lineHeight = "";
    item.style.fontFamily = "";
  }
  for (let item of span.values()) {
    item.style.fontSize = "";
    item.style.lineHeight = "";
    item.style.fontFamily = "";
  }
  for (let item of font.values()) {
    item.size = "";
    item.face = "微软雅黑";
  }
  for (let item of img.values()) {
    // item.width = "100%";
    item.style.width = "100%";
    item.style.height = "auto";

    if (item.getAttribute("src") === "" || !item.src)
      item.setAttribute("src", item.getAttribute("data-cfsrc") || item.getAttribute("oldsrc"));
    // item.height = "auto";
    item.parentNode.parentNode.style.textIndent = "";
    if (item.style.display === "none") item.style.display = "";
    if (item.style.visibility === "hidden") item.style.visibility = "";
  }
  return dom;
};

export { snippet, clearStyle };
